import styled from 'styled-components'

interface OptionButtonProps {
  active: boolean
  children: React.ReactNode
  id: string
  onClick: () => void
  style?: React.CSSProperties
  tooltip?: string
}

const ButtonContainer = styled.div`
  border-radius: 4px;

  &:first-of-type {
    button {
      border-radius: 4px 0 0 4px;
    }
  }

  &:last-of-type {
    button {
      border-radius: 0 4px 4px 0;
    }
  }

  &:only-of-type {
    button {
      border-radius: 4px;
    }
  }
`

const StyledOptionButton = styled.button.attrs({
  className: 'tds-detail-02'
})<{ active: boolean }>`
  border: none;
  width: var(--tds-spacing-element-40);
  height: var(--tds-spacing-element-32);

  background-color: ${({ active }) =>
    active ? 'var(--tds-green-100)' : 'inherit'};

  &:hover {
    cursor: pointer;
    background: ${({ active }) =>
      active ? 'var(--tds-green-100)' : 'var(--tds-grey-100)'};
  }
`

export const OptionButton = ({
  active,
  onClick,
  children,
  id,
  style
}: OptionButtonProps) => {
  return (
    <ButtonContainer>
      <StyledOptionButton
        onClick={onClick}
        id={id}
        active={active}
        style={style}
      >
        {children}
      </StyledOptionButton>
    </ButtonContainer>
  )
}
